import { loadable } from "../../../components/Loadable/loadable";

export default loadable(() => import(/* webpackChunkName: "LoginPage" */ './LoginPage'));
